import React, { useState } from "react";

const CTASection = ({ onCtaClick }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <section className="py-20 relative overflow-hidden">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600" />

      {/* Animated Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full filter blur-3xl" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full filter blur-3xl" />
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-12 md:p-16 border border-white/20">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-6">
            ¿Listo para aprobar tu examen?
          </h2>

          <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto">
            Únete a cientos de aspirantes que ya confían en PanamaBR. ¡Comienza
            hoy!
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={onCtaClick}
              className="group px-8 py-4 bg-white text-blue-600 text-lg font-bold rounded-2xl shadow-xl hover:shadow-2xl hover:scale-105 transition-all flex items-center justify-center gap-2"
            >
              <span>Comenzar ahora</span>
              <svg
                className="w-5 h-5 group-hover:translate-x-1 transition-transform"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M13 7l5 5m0 0l-5 5m5-5H6"
                />
              </svg>
            </button>

            {/* Botón que abre el modal */}
            <button
              onClick={() => setIsModalOpen(true)}
              className="px-8 py-4 bg-white/20 backdrop-blur-sm text-white border-2 border-white/40 text-lg font-bold rounded-2xl hover:bg-white/30 hover:border-white/60 transition-all"
            >
              Hablar con ventas
            </button>
          </div>

          <p className="text-sm text-white/70 mt-8">
            ✨ Acceso inmediato · Cancela cuando quieras
          </p>
        </div>
      </div>

      {/* --- MODAL DE VENTAS --- */}
      {isModalOpen && (
        <div className="fixed inset-0 z-[150] flex items-center justify-center p-4">
          {/* Overlay */}
          <div
            className="absolute inset-0 bg-slate-900/60 backdrop-blur-md"
            onClick={() => setIsModalOpen(false)}
          />

          {/* Contenido del Modal */}
          <div className="relative bg-white rounded-3xl p-8 md:p-12 max-w-md w-full shadow-2xl animate-in fade-in zoom-in duration-300">
            <button
              onClick={() => setIsModalOpen(false)}
              className="absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-600 transition-colors"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 text-blue-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <svg
                  className="w-8 h-8"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
              </div>

              <h3 className="text-2xl font-black text-slate-900 mb-2">
                Contacto de Ventas
              </h3>
              <p className="text-slate-500 mb-8">
                ¿Tienes dudas o necesitas ayuda? Escríbenos directamente:
              </p>

              <a
                href="mailto:go@mivx.com"
                className="block w-full py-4 bg-slate-100 rounded-2xl text-xl font-black text-blue-600 hover:bg-blue-50 transition-colors border-2 border-dashed border-blue-200 mb-6"
              >
                go@mivx.com
              </a>

              <button
                onClick={() => setIsModalOpen(false)}
                className="text-sm font-bold text-slate-400 hover:text-slate-600 transition-colors"
              >
                Cerrar ventana
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default CTASection;
